import { EasyImg } from 'src/components'
import { Search, FullScreen, User } from './headers'
import 'enasops/styles/layout/header.less'

const Header = () => {
  return (
    <div className='header'>
      <div className='header__left'>
        <EasyImg src={require('enasops/assets/layout/logo.png')} />
        <span>eNAS管理后台</span>
      </div>
      <div className='header__right'>
        <Search />
        <FullScreen />
        <User />
      </div>
    </div>
  )
}

export default Header
